import { FocusEvent, KeyboardEventHandler } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useMessageSnackbar } from 'services/hooks';
import { actions } from 'services/store/remixer';
import { selectProjectTitle } from 'services/store/remixer/selectors';
import { StyledInput } from './styled';

const MIN_INPUT_LENGTH = 1;
const MAX_INPUT_LENGTH = 100;

const EditableTitle = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { displayErrorSnackbar } = useMessageSnackbar();

  const storeSongTitle = useSelector(selectProjectTitle);

  const handleSubmit = (event: FocusEvent<HTMLInputElement>) => {
    const inputValue = event.target.value;

    if (inputValue.length < MIN_INPUT_LENGTH) {
      displayErrorSnackbar(
        t('messages:validation.minLength', {
          field: t('fields:remixerTitle'),
          length: MIN_INPUT_LENGTH,
        })
      );
      return;
    }

    if (inputValue.length > MAX_INPUT_LENGTH) {
      displayErrorSnackbar(
        t('messages:validation.maxLength', {
          field: t('fields:remixerTitle'),
          length: MAX_INPUT_LENGTH,
        })
      );
      return;
    }

    dispatch(actions.setTitle(inputValue));
  };

  const handleInputKeyDown: KeyboardEventHandler<HTMLInputElement> = (
    event
  ) => {
    const target = event.target as HTMLInputElement;
    const { key } = event;
    if (key === 'Enter') {
      target.blur();
      return;
    }
    if (event.key === 'Escape') {
      target.value = storeSongTitle || '';
      target.blur();
    }
  };

  return (
    <StyledInput
      onKeyDown={handleInputKeyDown}
      disableUnderline
      aria-label="Edit studio project title input"
      inputProps={{
        'data-testid': 'title-input',
        maxLength: MAX_INPUT_LENGTH,
        minLength: MIN_INPUT_LENGTH,
        onBlur: handleSubmit,
        defaultValue: storeSongTitle || '',
      }}
    />
  );
};

export default EditableTitle;
